import styled from "styled-components";

export const Main = styled.div`
  grid-area: "main";
`;
